// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-simple-page',
    props: {
        showLogo: {
            type: Boolean,
            required: false,
            default: true,
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        backLinkPath: {
            type: String,
            required: false,
            default: ''
        },
    }
});
// #endregion
